// Contenido del Centro de ayuda del CRM -- ÚNICA fuente del texto de los 32
// artículos (29 pantallas del inventario -- ver más abajo, 3 de ellas
// terminaron necesitando dos artículos cada una). Mismo patrón que
// ayudaArticulos.js de Citas: datos puros, sin JSX, sin componentes de
// ícono, nada de HTML embebido -- la pantalla (pages/Ayuda/index.js)
// decide cómo pintar `**negritas**` y cómo enlazar `verTambien`.
//
// Ver TAREA: centro de ayuda del CRM. Cubre las 29 pantallas reales del
// inventario funcional (Fase 1-2), verificadas contra el código de staging
// al momento de escribir esto -- no contra el menú tal cual, porque varias
// pantallas usan un nombre en el menú lateral y OTRO distinto en el título
// que muestran por dentro (ver 'panel-de-servicio-momentos',
// 'talk-ai-es-prompts', 'programacion-es-programas' abajo: no es un typo de
// este archivo, es así en el producto). Las fusiones (Listados de Contactos
// dentro de Contactos, Cumpleaños dentro de Campañas, Campos personalizados
// con Flujos, Admin conexiones como ver también de Empresas, Notificaciones
// y Whitelabel dentro de Configuración) fueron acordadas antes de escribir.
//
// Campo nuevo que Citas no necesitaba: `audiencia` -- 'negocio' (dueño del
// negocio o su agente) o 'shessai' (equipo/socios de Shessai, panel
// superadmin). Sirve para filtrar el índice más adelante si hiciera falta
// (ver pages/Ayuda/index.js para cómo se activaría ese filtro).
// Los artículos 'shessai' están escritos para alguien que todavía no existe
// como lector real -- un socio nuevo -- así que asumen CERO conocimiento de
// cómo está armada la plataforma por dentro, no que sea alguien técnico.
//
// Campo agregado al construir la pantalla (Fase 4): `destacado` -- boolean,
// igual que en Citas, para la sección "Lo más consultado" del índice. Sin
// esto la pantalla tendría que hardcodear cuáles mostrar ahí, violando la
// regla de cero contenido hardcodeado en el componente.

export const AYUDA_CATEGORIAS = [
  { id: 'atencion', nombre: 'Atención al cliente', icono: 'atencion' },
  { id: 'analisis', nombre: 'Análisis y reportes', icono: 'analisis' },
  { id: 'automatizacion', nombre: 'Automatización', icono: 'automatizacion' },
  { id: 'administracion', nombre: 'Administración del negocio', icono: 'admin' },
  { id: 'shessai', nombre: 'Panel Shessai', icono: 'shessai' },
  { id: 'sistema', nombre: 'Sistema', icono: 'sistema' },
];

// Forma de cada artículo -- igual a Citas, más `audiencia`:
// - slug, categoria (una de AYUDA_CATEGORIAS.id), pantallas (ids de rutas
//   reales del CRM, para el ícono de ayuda contextual que llega después),
//   destacado (boolean, "Lo más consultado"), audiencia ('negocio' |
//   'shessai'), tipo ('instructiva' | 'explicativa'), titulo, actualizado,
//   contexto (cuándo aplica).
// - pasos: array de strings con **negritas** para nombres exactos de
//   pantalla/botón -- la secuencia de clics (instructiva) o los puntos que
//   explican el concepto (explicativa).
// - rama: string o null -- "¿pero si tu caso es otro?", nunca un link.
// - verTambien: array de { slug, titulo }, aparte de la rama.
export const AYUDA_ARTICULOS = [

  // ══════════════════════ ATENCIÓN AL CLIENTE ══════════════════════

  {
    slug: 'tickets-dia-a-dia',
    categoria: 'atencion',
    pantallas: ['tickets'],
    destacado: true,
    audiencia: 'negocio',
    tipo: 'instructiva',
    titulo: 'Tickets: tu día a día',
    actualizado: '2026-09-15',
    contexto: 'En el menú esta pantalla dice **Tickets**, pero por dentro se llama **Inbox** -- es donde vas a pasar la mayor parte del día, viendo y respondiendo conversaciones de WhatsApp.',
    pasos: [
      'Arriba tienes cuatro pestañas: **Abiertas** (en curso), **Pendientes** (sin asignar o esperando), **Grupos** y **Cerradas**. Un contador junto a cada una te dice cuántas hay, y **Sin leer** marca las que tienen mensajes nuevos sin abrir.',
      'Toca una conversación para abrirla y responder normal, como en cualquier WhatsApp. Si el contacto mandó un mensaje de voz, en el menú de tres puntos de la conversación puedes activar **¿Aceptar audios del contacto?** para decidir si se reciben o no.',
      'Para pasarle la conversación a otro agente o Departamento, usa **Transferir** en ese mismo menú de tres puntos -- abre un selector de a quién o a qué Departamento mandarla.',
      'Para cerrar la sesión, cambia su estado con el ícono correspondiente. Si además quieres saltarte el mensaje de despedida automático, usa **Cerrar sin despedida** desde el menú de tres puntos en vez del cierre normal.',
      'El buscador de arriba busca por nombre o número de contacto. Si activas el interruptor **MSG** al lado derecho del buscador, la búsqueda entra también al contenido de los mensajes, no solo al nombre del contacto.',
    ],
    rama: '¿Necesitas cerrar varias sesiones de golpe, no una por una? Eso es otra pantalla -- revisa el artículo del botón **Cerrar todos**, porque no hace exactamente lo que su nombre sugiere.',
    verTambien: [
      { slug: 'inbox-cerrar-todos', titulo: "Inbox: qué hace 'Cerrar todos' antes de tocarlo" },
      { slug: 'departamentos-editor-chatbot', titulo: 'Departamentos: dónde está el editor del chatbot' },
    ],
  },
  {
    slug: 'inbox-cerrar-todos',
    categoria: 'atencion',
    pantallas: ['tickets'],
    destacado: true,
    audiencia: 'negocio',
    tipo: 'instructiva',
    titulo: "Inbox: qué hace 'Cerrar todos' antes de tocarlo",
    actualizado: '2026-09-15',
    contexto: 'En el menú esta pantalla dice **Tickets**, pero por dentro se llama **Inbox** -- es donde vives la mayor parte del día, viendo y respondiendo conversaciones. Usa esto antes de tocar el botón que cierra varias sesiones de una vez.',
    pasos: [
      'Las conversaciones se organizan en pestañas: **Abiertas**, **Pendientes**, **Grupos** y **Cerradas** -- y además puedes filtrar por Departamento arriba.',
      'Para cerrar una sola sesión, ábrela y cambia su estado con el ícono correspondiente en la conversación.',
      'Abajo, si eres administrador, hay un botón **Cerrar todos**. Al tocarlo aparece un aviso rápido preguntando "¿Cerrar todas las sesiones?" con dos botones: **Sí, cerrar** y **NO**.',
      'Ese aviso no te dice cuántas sesiones va a cerrar. Y "todas" no es literal: solo cierra las que están **visibles en tu pestaña y Departamento filtrados en ese momento** -- no todas las conversaciones abiertas de la empresa.',
    ],
    rama: '¿Quieres estar seguro de a cuántas afecta antes de confirmar? Quita cualquier filtro de Departamento y revisa el contador de la pestaña **Abiertas** primero -- ese número es el que se va a cerrar.',
    verTambien: [
      { slug: 'tickets-dia-a-dia', titulo: 'Tickets: tu día a día' },
      { slug: 'departamentos-editor-chatbot', titulo: 'Departamentos: dónde está el editor del chatbot' },
    ],
  },
  {
    slug: 'kanban-tablero',
    categoria: 'atencion',
    pantallas: ['Kanban', 'TagsKanban'],
    destacado: false,
    audiencia: 'negocio',
    tipo: 'instructiva',
    titulo: 'Kanban: mover tarjetas y asignar valor de oportunidad',
    actualizado: '2026-09-15',
    contexto: 'Úsalo cuando prefieres ver tus conversaciones como un tablero de oportunidades de venta en vez de una lista de chats. Solo aparece si tu plan tiene Kanban habilitado.',
    pasos: [
      'Cada tarjeta es un ticket. Arrástrala entre columnas para mover al contacto de una etapa a otra.',
      'Dentro de la tarjeta, toca **Asignar Valor** (o **Editar Valor de la Oportunidad** si ya tiene uno) para registrar cuánto vale esa venta potencial.',
      'Las columnas mismas -- los nombres de las etapas -- no se editan aquí: se crean y renombran en **TagsKanban**, una pantalla aparte a la que se llega desde el propio Kanban.',
    ],
    rama: '¿Vas a eliminar una etapa completa en TagsKanban? Antes revisa si tiene tarjetas activas -- el sistema pide confirmación, pero muévelas a otra etapa primero si no quieres perderles el rastro.',
    verTambien: [{ slug: 'contactos-gestion', titulo: 'Contactos: importar, seleccionar y quitar etiquetas' }],
  },
  {
    slug: 'chat-interno-equipo',
    categoria: 'atencion',
    pantallas: ['chats'],
    destacado: false,
    audiencia: 'negocio',
    tipo: 'explicativa',
    titulo: 'Chat Interno: hablar con tu equipo sin mezclarlo con clientes',
    actualizado: '2026-09-15',
    contexto: 'Solo aparece en el menú si tu plan tiene el chat interno habilitado.',
    pasos: [
      '**Chat Interno** es mensajería entre los agentes de tu empresa -- nada de lo que escribas ahí le llega a un cliente, ni comparte hilo con ninguna conversación de WhatsApp.',
      'El número junto al ícono en el menú son tus mensajes internos sin leer, no tickets pendientes -- son contadores independientes.',
    ],
    rama: null,
    verTambien: [],
  },
  {
    slug: 'contactos-gestion',
    categoria: 'atencion',
    pantallas: ['contacts', 'contact-lists'],
    destacado: true,
    audiencia: 'negocio',
    tipo: 'instructiva',
    titulo: 'Contactos: importar, seleccionar y quitar etiquetas',
    actualizado: '2026-09-15',
    contexto: 'Úsalo para dar de alta contactos, organizarlos en listados para campañas, o limpiar tu base.',
    pasos: [
      'El botón **Importar / Exportar** (arriba) te deja traer contactos desde el teléfono conectado o desde un Excel.',
      'Para armar un listado usado en **Campañas**, ve a **Listados de Contactos** -- es una pantalla aparte, pensada para segmentar antes de enviar un mensaje masivo, no para editar contactos.',
      'Puedes seleccionar varios contactos con el check de cada fila y usar **Eliminar seleccionados** -- pide confirmación antes de borrarlos.',
      'Para quitar una sola etiqueta de un contacto (sin borrar al contacto), ábrelo y toca la **X** junto a la etiqueta en su lista de tags.',
    ],
    rama: 'Ojo con lo último: quitar una etiqueta así **no pide confirmación** -- se borra apenas tocas la X, sin aviso ni deshacer.',
    verTambien: [{ slug: 'tags-etiquetas', titulo: 'Tags: para qué sirven las etiquetas de sesiones' }],
  },
  {
    slug: 'tags-etiquetas',
    categoria: 'atencion',
    pantallas: ['tags'],
    destacado: false,
    audiencia: 'negocio',
    tipo: 'explicativa',
    titulo: 'Tags: para qué sirven las etiquetas de sesiones',
    actualizado: '2026-09-15',
    contexto: 'No confundir con las etiquetas de contacto de la pantalla Contactos, ni con las columnas de Kanban (esas se llaman TagsKanban) -- **Tags** es un tercer catálogo: etiquetas para clasificar sesiones de Inbox.',
    pasos: [
      'Cada tag tiene un nombre y un color, y sirve para filtrar conversaciones más tarde -- por ejemplo, marcar "Urgente" o "Reclamo".',
      'Se crean y eliminan desde esta misma pantalla. Eliminar un tag pide confirmación, y deja de estar disponible para todas las sesiones donde estaba puesto.',
    ],
    rama: null,
    verTambien: [{ slug: 'kanban-tablero', titulo: 'Kanban: mover tarjetas y asignar valor de oportunidad' }],
  },
  {
    slug: 'respuestas-rapidas',
    categoria: 'atencion',
    pantallas: ['quick-messages'],
    destacado: false,
    audiencia: 'negocio',
    tipo: 'instructiva',
    titulo: 'Respuestas Rápidas: crear atajos de mensaje',
    actualizado: '2026-09-15',
    contexto: 'Úsalo si respondes lo mismo seguido -- horarios, ubicación, precios -- y no quieres escribirlo cada vez.',
    pasos: [
      'En **Respuestas Rápidas**, toca **Agregar** y define un atajo corto (por ejemplo "/horario") y el mensaje completo que va a reemplazarlo.',
      'Puedes **Adjuntar Archivo** al atajo si siempre mandas una imagen o PDF junto con ese texto.',
      'Al escribir en una sesión de **Inbox**, tu atajo aparece como sugerencia apenas empiezas a teclearlo.',
    ],
    rama: null,
    verTambien: [],
  },

  // ══════════════════════ ANÁLISIS Y REPORTES ══════════════════════

  {
    slug: 'dashboard-metricas',
    categoria: 'analisis',
    pantallas: ['dashboard'],
    destacado: false,
    audiencia: 'negocio',
    tipo: 'explicativa',
    titulo: 'Dashboard: qué significa cada pestaña',
    actualizado: '2026-09-15',
    contexto: 'Es lo primero que ves al entrar al CRM. Solo lo ven perfiles con acceso de administrador.',
    pasos: [
      '**Indicadores** -- números generales de atención: sesiones abiertas, pendientes, tiempo de respuesta.',
      '**Evaluaciones** -- cómo calificaron los clientes la atención recibida, cuando tienes encuestas activas.',
      '**Agentes** -- desempeño por persona: cuántas sesiones atendió cada quien y en cuánto tiempo.',
    ],
    rama: null,
    verTambien: [{ slug: 'reportes-exportar', titulo: 'Reportes: filtrar por fecha y exportar a Excel' }],
  },
  {
    slug: 'reportes-exportar',
    categoria: 'analisis',
    pantallas: ['reports'],
    destacado: false,
    audiencia: 'negocio',
    tipo: 'instructiva',
    titulo: 'Reportes: filtrar por fecha y exportar a Excel',
    actualizado: '2026-09-15',
    contexto: 'Úsalo cuando necesitas el historial de atención fuera del CRM -- para una reunión, una auditoría, o cruzarlo con otro sistema.',
    pasos: [
      'Define **Fecha inicial** y **Fecha final** para acotar el rango.',
      'Marca **Solo evaluados** si únicamente te interesan las sesiones que el cliente calificó.',
      'Toca **Filtrar** -- los resultados no se cargan solos, hay que presionarlo después de definir los filtros.',
      'El ícono de exportar (arriba a la derecha de la tabla) descarga lo filtrado como Excel.',
    ],
    rama: null,
    verTambien: [{ slug: 'dashboard-metricas', titulo: 'Dashboard: qué significa cada pestaña' }],
  },
  {
    slug: 'panel-de-asistencia-que-muestra',
    categoria: 'analisis',
    pantallas: ['moments'],
    destacado: false,
    audiencia: 'negocio',
    tipo: 'explicativa',
    titulo: 'Panel de Asistencia: qué muestra',
    actualizado: '2026-09-15',
    contexto: 'En el menú esta pantalla dice **Panel de Asistencia**, pero el título que ves adentro dice **Panel de servicio** -- es la misma pantalla, un monitor en vivo de cómo está la atención en este momento, no una bandeja para trabajar todo el día como el Inbox.',
    pasos: [
      'Hay una tarjeta por cada agente conectado, con su nombre, un punto verde o gris según esté **En línea** o **Desconectado**, y un número con la cantidad de sesiones que tiene activas.',
      'Aparte está la tarjeta **Bandeja compartida**: agrupa las sesiones que todavía no tienen agente asignado. Si tiene sesiones, se marca en amarillo con la etiqueta **"necesita agente"**.',
      'En las tarjetas de agentes normales, tocar una sesión de la lista la abre ahí mismo para revisarla, sin salir de esta pantalla.',
      'En la Bandeja compartida no puedes abrir una sesión directo: primero tienes que tocar su botón **Asignarme** individual (aparece en cada fila) para que pase a ser tuya -- recién ahí se puede leer y responder.',
    ],
    rama: '¿Tienes muchas sesiones sin asignar y prefieres tomarlas todas de una? Existe un botón para eso, pero antes de usarlo revisa el artículo de al lado -- confirma la cantidad exacta, pero igual te hace responsable de todas de golpe.',
    verTambien: [{ slug: 'panel-de-asistencia-asignarme-todos', titulo: "Panel de Asistencia: qué hace 'Asignarme todos'" }],
  },
  {
    slug: 'panel-de-asistencia-asignarme-todos',
    categoria: 'analisis',
    pantallas: ['moments'],
    destacado: false,
    audiencia: 'negocio',
    tipo: 'instructiva',
    titulo: "Panel de Asistencia: qué hace 'Asignarme todos'",
    actualizado: '2026-09-15',
    contexto: 'En el menú esta pantalla dice **Panel de Asistencia**, pero el título que ves adentro dice **Panel de servicio** -- es la misma pantalla, muestra en vivo qué agentes están atendiendo y cuántas sesiones sin asignar hay esperando.',
    pasos: [
      'Cada agente aparece con sus sesiones activas. Si hay conversaciones **Sin asignar**, ves un aviso "Necesita agente" y un botón **Asignarme todos**.',
      'Al tocarlo, el sistema sí pregunta antes de asignar: "¿Asignarte los N tickets pendientes?" -- con el número real. Confirmar te vuelve responsable de todas esas sesiones de una sola vez.',
    ],
    rama: 'Si solo quieres tomar una o dos, no uses ese botón -- en la Bandeja compartida cada sesión tiene su propio botón **Asignarme** individual, junto a la fila.',
    verTambien: [
      { slug: 'panel-de-asistencia-que-muestra', titulo: 'Panel de Asistencia: qué muestra' },
      { slug: 'inbox-cerrar-todos', titulo: "Inbox: qué hace 'Cerrar todos' antes de tocarlo" },
    ],
  },

  // ══════════════════════ AUTOMATIZACIÓN ══════════════════════

  {
    slug: 'campanas-mensajes-masivos',
    categoria: 'automatizacion',
    pantallas: ['campaigns', 'birthday-settings'],
    destacado: false,
    audiencia: 'negocio',
    tipo: 'instructiva',
    titulo: 'Campañas: mensajes masivos y cumpleaños automáticos',
    actualizado: '2026-09-15',
    contexto: 'Solo aparece si tu plan tiene Campañas habilitado. Úsalo para mandar un mismo mensaje a un listado de contactos, de una vez o en fechas programadas.',
    pasos: [
      'Toca **Nueva Campaña**, elige el **Listado de Contactos** (armado antes en esa pantalla) y la **Conexión** de WhatsApp que va a enviar.',
      'Puedes escribir hasta 5 variantes de mensaje -- el sistema las reparte entre los contactos para no mandar el texto idéntico a todos.',
      'Si programaste una campaña recurrente y quieres detenerla a mitad de camino, usa **Detener Recurrencia** en sus acciones -- no hace falta borrarla entera.',
      'Los mensajes de cumpleaños automáticos NO se configuran aquí: viven en **Config. Cumpleaños**, una pantalla aparte dentro de Administración. Es, en el fondo, una campaña recurrente que dispara sola según la fecha de nacimiento guardada en cada contacto.',
    ],
    rama: '¿Solo quieres avisar algo puntual, sin listado ni programación? Revisa si te sirve más una **Frase automática**, que dispara sola cuando el contacto escribe algo específico, en vez de armar una campaña completa.',
    verTambien: [
      { slug: 'campanas-configuracion', titulo: 'Configuraciones de Campañas: límites antes de enviar' },
      { slug: 'frases-automaticas', titulo: 'Frases automáticas: disparar algo cuando el contacto escribe' },
    ],
  },
  {
    slug: 'campanas-configuracion',
    categoria: 'automatizacion',
    pantallas: ['campaigns-config'],
    destacado: false,
    audiencia: 'negocio',
    tipo: 'explicativa',
    titulo: 'Configuraciones de Campañas: límites antes de enviar',
    actualizado: '2026-09-15',
    contexto: 'Es una pantalla separada de Campañas -- acá defines las reglas generales que aplican a TODAS tus campañas, no una campaña puntual.',
    pasos: [
      'El **intervalo de disparo aleatorio** espacia los envíos entre contactos, para no mandar todo en el mismo segundo.',
      'El **intervalo mayor** aplica cada cierta cantidad de mensajes, como una pausa extra -- útil para reducir el riesgo de que WhatsApp marque tu número como spam por enviar demasiado rápido.',
    ],
    rama: null,
    verTambien: [{ slug: 'campanas-mensajes-masivos', titulo: 'Campañas: mensajes masivos y cumpleaños automáticos' }],
  },
  {
    slug: 'flowbuilder-flujo-conversacion',
    categoria: 'automatizacion',
    pantallas: ['flowbuilders', 'flowbuilder'],
    destacado: false,
    audiencia: 'negocio',
    tipo: 'instructiva',
    titulo: 'Flujo de conversación: armar un flujo con el editor visual',
    actualizado: '2026-09-15',
    contexto: 'Solo visible si tu usuario tiene el flag de Flujos habilitado. Es un lienzo donde conectas bloques -- no se escribe código.',
    pasos: [
      'Desde **Flujo de conversación** creas un flujo nuevo y entras a su editor visual.',
      'Arrastra bloques como condición, menú de opciones, agregar tag o quitar tag, y conéctalos con líneas para armar el camino que sigue la conversación.',
      'El bloque de **quitar tag** se explica solo en el lienzo, pero la etiqueta se elimina del contacto en el momento exacto en que el flujo pasa por ahí -- sin aviso aparte, porque es una acción automática, no un clic tuyo.',
    ],
    rama: 'Si estás por editar un flujo que ya está activo y en uso, ten en cuenta que los contactos que están a mitad de camino en la versión anterior pueden verse afectados por el cambio -- pruébalo primero con un contacto de prueba si el flujo es importante.',
    verTambien: [{ slug: 'frases-automaticas', titulo: 'Frases automáticas: disparar algo cuando el contacto escribe' }],
  },
  {
    slug: 'frases-automaticas',
    categoria: 'automatizacion',
    pantallas: ['phrase-lists'],
    destacado: false,
    audiencia: 'negocio',
    tipo: 'instructiva',
    titulo: 'Frases automáticas: disparar algo cuando el contacto escribe',
    actualizado: '2026-09-15',
    contexto: 'Es distinto a Campañas: acá no eliges a quién ni cuándo mandar -- defines una frase, y el sistema actúa solo cuando UN contacto la escribe.',
    pasos: [
      'Toca **Nueva campaña con flujo por frase**, dale nombre al disparador y define **qué frase desencadena el flujo**.',
      'Elige la **Conexión** de WhatsApp donde vas a escuchar esa frase.',
      'Guarda -- a partir de ahí, cualquier contacto que le escriba exactamente esa frase a esa conexión activa la respuesta configurada.',
    ],
    rama: null,
    verTambien: [{ slug: 'flowbuilder-flujo-conversacion', titulo: 'Flujo de conversación: armar un flujo con el editor visual' }],
  },
  {
    slug: 'lista-de-archivos',
    categoria: 'automatizacion',
    pantallas: ['files'],
    destacado: false,
    audiencia: 'negocio',
    tipo: 'explicativa',
    titulo: 'Lista de archivos: no es un repositorio general de documentos',
    actualizado: '2026-09-15',
    contexto: 'El menú la llama **Lista de archivos**, pero el título de la pantalla es más claro sobre su propósito real: **Archivos de respuesta rápida**.',
    pasos: [
      'Esta pantalla guarda archivos (imágenes, PDF, audio) para que los uses como adjuntos dentro de **Respuestas Rápidas** o de un **Flujo de conversación** -- no es un lugar para archivar documentos generales de la empresa.',
      'Sube el archivo una vez aquí, y después lo eliges desde esas otras pantallas en vez de subirlo de nuevo cada vez.',
    ],
    rama: null,
    verTambien: [{ slug: 'respuestas-rapidas', titulo: 'Respuestas Rápidas: crear atajos de mensaje' }],
  },
  {
    slug: 'llamadas-ia-asistente-voz',
    categoria: 'automatizacion',
    pantallas: ['llamadas-ia'],
    destacado: false,
    audiencia: 'negocio',
    tipo: 'instructiva',
    titulo: 'Llamadas IA: configurar un asistente de voz',
    actualizado: '2026-09-15',
    contexto: 'Es para llamadas telefónicas reales, no para WhatsApp -- un asistente con voz que puede contestar el teléfono de tu negocio.',
    pasos: [
      'En el panel de **Asistentes** (a la izquierda) creas un agente nuevo.',
      'Con el agente seleccionado, la pestaña **Configuración** define cómo debe comportarse y qué debe preguntar en la llamada.',
      'La pestaña **Números** asigna el número de teléfono que va a atender ese agente.',
      'La pestaña **Llamadas** muestra el historial de lo que ya contestó.',
    ],
    rama: null,
    verTambien: [],
  },

  // ══════════════════════ ADMINISTRACIÓN DEL NEGOCIO ══════════════════════

  {
    slug: 'conexiones-conectar-canales',
    categoria: 'administracion',
    pantallas: ['connections'],
    destacado: true,
    audiencia: 'negocio',
    tipo: 'instructiva',
    titulo: 'Conexiones: conectar y administrar tus canales',
    actualizado: '2026-09-15',
    contexto: 'Acá conectas y administras los canales por los que tu negocio recibe mensajes: WhatsApp, Facebook e Instagram.',
    pasos: [
      'Toca **Agregar** y elige el tipo de canal: **WhatsApp**, **WhatsApp Oficial** o **WhatsApp Cloud API** -- cuáles ves disponibles depende de tu plan.',
      'Para un WhatsApp normal, después de crearlo aparece un botón para mostrar el **código QR**: escanéalo con el teléfono que vas a usar, igual que enlazar WhatsApp Web.',
      'Cada conexión de la lista muestra su estado: **Conectado**, **Desconectado**, **QR Code** (esperando que lo escanees), **Conectando** o **Emparejando**.',
      'Para editar una conexión ya creada, ábrela -- el modal trae varias pestañas: **General**, **Mensajes**, **Evaluaciones**, **Integraciones** y **Horario de trabajo**.',
    ],
    rama: '¿Una sola conexión dejó de funcionar y las demás están bien? No uses el botón general de reinicio -- edita esa conexión puntual y usa su propia opción para reconectarla, sin tocar a las demás.',
    verTambien: [{ slug: 'conexiones-reiniciar', titulo: "Conexiones: por qué 'Reiniciar Conexiones' no pide confirmación" }],
  },
  {
    slug: 'conexiones-reiniciar',
    categoria: 'administracion',
    pantallas: ['connections'],
    destacado: true,
    audiencia: 'negocio',
    tipo: 'instructiva',
    titulo: "Conexiones: por qué 'Reiniciar Conexiones' no pide confirmación",
    actualizado: '2026-09-15',
    contexto: 'Acá conectas y administras tus números de WhatsApp, Facebook e Instagram. Lee esto antes de tocar el botón de reinicio, no después.',
    pasos: [
      'Cada conexión muestra su estado -- conectada, esperando código QR, desconectada.',
      'Arriba hay un botón **Reiniciar Conexiones**. A diferencia de otras acciones de esta misma pantalla, este botón actúa apenas lo tocas: no hay ventana de confirmación, ni aviso previo.',
      'Reiniciar tumba las sesiones activas de TODAS tus conexiones de WhatsApp al mismo tiempo -- no solo la que estabas mirando.',
    ],
    rama: '¿Solo una conexión específica está fallando? No uses este botón general -- edítala individualmente y usa su propia opción de reconexión, para no afectar a las demás que sí estaban funcionando bien.',
    verTambien: [{ slug: 'conexiones-conectar-canales', titulo: 'Conexiones: conectar y administrar tus canales' }],
  },
  {
    slug: 'usuarios-permisos',
    categoria: 'administracion',
    pantallas: ['users'],
    destacado: true,
    audiencia: 'negocio',
    tipo: 'instructiva',
    titulo: 'Usuarios: qué controla la pestaña Permisos',
    actualizado: '2026-09-15',
    contexto: 'Casi cada botón sensible del CRM (cerrar sesiones ajenas, borrar contactos, editar o eliminar una conexión) depende de un permiso que se activa o desactiva acá -- no solo del perfil Admin/Agente.',
    pasos: [
      'Al crear o editar un usuario, la pestaña **General** define su nombre, correo, perfil y Departamentos asignados.',
      'La pestaña **Permisos** es la que de verdad decide qué botones destructivos va a ver ese usuario en el resto del CRM.',
      'Si un agente te dice que no ve un botón que tú sí ves (como Cerrar todos, o eliminar una conexión), revisa primero esta pestaña antes de asumir que es un error del sistema.',
    ],
    rama: null,
    verTambien: [{ slug: 'conexiones-reiniciar', titulo: "Conexiones: por qué 'Reiniciar Conexiones' no pide confirmación" }],
  },
  {
    slug: 'departamentos-editor-chatbot',
    categoria: 'administracion',
    pantallas: ['queues'],
    destacado: true,
    audiencia: 'negocio',
    tipo: 'instructiva',
    titulo: 'Departamentos: dónde está el editor del chatbot',
    actualizado: '2026-09-15',
    contexto: 'Un Departamento es un equipo de trabajo (Ventas, Soporte, Facturación...). Lo que no es obvio: el editor del bot automático de bienvenida no tiene pantalla propia -- vive escondido dentro de editar un Departamento.',
    pasos: [
      'Toca **Agregar Departamento** o edita uno existente -- se abre un modal con la pestaña **Datos**.',
      'Ahí defines nombre, color, **mensaje de saludo** y **mensaje fuera de horario**.',
      'Más abajo en ese mismo modal, al activar el bot para ese Departamento, aparece el editor de opciones del chatbot -- las respuestas automáticas por número que el cliente puede elegir. No es una pantalla aparte: es una sección que solo se ve si scrolleas dentro del modal de edición.',
    ],
    rama: null,
    verTambien: [{ slug: 'integraciones-departamento', titulo: 'Integraciones: conectar un Departamento a un bot externo' }],
  },
  {
    slug: 'flujos-y-campos-personalizados',
    categoria: 'administracion',
    pantallas: ['flujos', 'custom-fields'],
    destacado: false,
    audiencia: 'negocio',
    tipo: 'explicativa',
    titulo: 'Flujos y Campos personalizados: dos cosas distintas, mismo grupo del menú',
    actualizado: '2026-09-15',
    contexto: 'Aparecen uno junto al otro en el menú y es fácil confundirlos con Flujo de conversación (FlowBuilder) -- son tres cosas diferentes.',
    pasos: [
      '**Flujos** son bases de datos a medida que puede usar el bot -- por ejemplo, una lista de productos con precio que el flujo consulta al responder.',
      'En **Flujos**, el ícono de lápiz de cada fila SOLO renombra ese flujo -- no edita su contenido ni su estructura, aunque el ícono sugiera más.',
      '**Campos personalizados** son datos extra para tus contactos -- no para el bot. Cada campo tiene un tipo: Texto, Número, Fecha, Selector, Booleano o Imagen.',
    ],
    rama: null,
    verTambien: [{ slug: 'flowbuilder-flujo-conversacion', titulo: 'Flujo de conversación: armar un flujo con el editor visual' }],
  },
  {
    slug: 'integraciones-departamento',
    categoria: 'administracion',
    pantallas: ['queue-integration'],
    destacado: false,
    audiencia: 'negocio',
    tipo: 'instructiva',
    titulo: 'Integraciones: conectar un Departamento a un bot externo',
    actualizado: '2026-09-15',
    contexto: 'Solo aparece si tu plan tiene Integraciones habilitado. Es para cuando el bot de respuestas no vive dentro del CRM, sino en un servicio externo.',
    pasos: [
      'Toca **Agregar Proyecto** y elige el tipo: **Typebot**, **DialogFlow**, **n8n**, **Webhook** o **SGP**.',
      'Cada tipo pide datos distintos -- por ejemplo Typebot pide su identificador de proyecto (slug), DialogFlow pide sus credenciales.',
      'Una vez guardada, la integración queda disponible para asignarla a un Departamento desde su modal de edición.',
    ],
    rama: null,
    verTambien: [{ slug: 'departamentos-editor-chatbot', titulo: 'Departamentos: dónde está el editor del chatbot' }],
  },
  {
    slug: 'talk-ai-es-prompts',
    categoria: 'administracion',
    pantallas: ['prompts'],
    destacado: false,
    audiencia: 'negocio',
    tipo: 'instructiva',
    titulo: 'Talk.Ai: configurar el asistente de IA (en el menú dice Talk.Ai, adentro dice Prompts)',
    actualizado: '2026-09-15',
    contexto: 'Solo aparece si tu plan tiene IA habilitada. En el menú lateral vas a buscarlo como **Talk.Ai**; al entrar, el título de la pantalla dice **Prompts** -- es la misma pantalla, no te equivocaste de lugar.',
    pasos: [
      'Cada prompt define cómo responde la IA para un Departamento: el texto de **Prompt** (las instrucciones que le das a la IA), tu **API Key**, y cuánto puede "improvisar" con **Temperatura**.',
      '**Máx. tokens** y **Máx. mensajes** limitan qué tan largas pueden ser las respuestas y cuántos mensajes recuerda de la conversación.',
      'Si activas respuesta por voz, **Voice Key** y **Voice Region** configuran el servicio de síntesis de voz.',
    ],
    rama: null,
    verTambien: [{ slug: 'departamentos-editor-chatbot', titulo: 'Departamentos: dónde está el editor del chatbot' }],
  },
  {
    slug: 'billeteras-contactos',
    categoria: 'administracion',
    pantallas: ['wallets'],
    destacado: false,
    audiencia: 'negocio',
    tipo: 'explicativa',
    titulo: 'Billeteras de Contactos: por qué un contacto le pertenece a un agente',
    actualizado: '2026-09-15',
    contexto: 'Solo la ven perfiles admin, y solo si tu empresa tiene activado dirigir sesiones a billeteras. Es para negocios donde cada agente atiende siempre a los mismos clientes (una cartera fija), no a quien conteste primero.',
    pasos: [
      'Una **Billetera** conecta un contacto con el agente responsable de él -- cuando ese contacto escribe, el sistema intenta dirigir la sesión directo a su agente asignado.',
      'Se asigna eligiendo el usuario y, si aplica, el Departamento, y buscando al contacto para vincularlo.',
    ],
    rama: null,
    verTambien: [],
  },
  {
    slug: 'programacion-es-programas',
    categoria: 'administracion',
    pantallas: ['schedules'],
    destacado: false,
    audiencia: 'negocio',
    tipo: 'instructiva',
    titulo: 'Programación: mandar un mensaje en una fecha futura',
    actualizado: '2026-09-15',
    contexto: 'En el menú se llama **Programación**; el título de la pantalla dice **Programas** -- misma pantalla otra vez con dos nombres. Solo aparece si tu plan la tiene habilitada. Úsala para dejar un mensaje listo que se envía solo en una fecha y hora futuras.',
    pasos: [
      'Toca **Nuevo Programa**, elige el contacto y escribe el mensaje.',
      'Define la fecha y hora de envío -- el sistema lo manda solo, no hace falta que el CRM esté abierto en ese momento.',
      'Puedes revisar el estado de cada programa en la tabla: si ya se envió o sigue pendiente.',
    ],
    rama: null,
    verTambien: [{ slug: 'campanas-mensajes-masivos', titulo: 'Campañas: mensajes masivos y cumpleaños automáticos' }],
  },

  // ══════════════════════ PANEL SHESSAI ══════════════════════
  // Escritos para un socio o alguien del equipo Shessai que recién entra a
  // este panel -- sin dar por sentado que sabe qué es "multi-empresa",
  // "MRR" o "Meta Cloud API". Se explica cada término la primera vez que
  // aparece.

  {
    slug: 'empresas-panel-superadmin',
    categoria: 'shessai',
    pantallas: ['companies'],
    destacado: false,
    audiencia: 'shessai',
    tipo: 'instructiva',
    titulo: 'Empresas: administrar a todos los negocios que usan el CRM',
    actualizado: '2026-09-15',
    contexto: 'Shessai no le vende el CRM a un solo negocio: cada barbería, clínica o comercio que lo usa es una "Empresa" separada dentro del mismo sistema, con sus propios datos, sin que una vea la información de la otra. Esta pantalla es donde ves y administras a todas ellas de un vistazo -- solo la ven cuentas de Shessai, nunca un cliente.',
    pasos: [
      'La lista muestra cada Empresa con su plan, si tiene activo el chip **Citas** (nuestra otra plataforma, de reservas de citas -- una empresa puede tener el CRM sin tener Citas, o ambas), su última conexión y si está Activa o Inactiva.',
      'Tocar una fila abre el detalle de esa Empresa: ahí ves y cambias su plan, y revisas cómo va su proceso de alta (onboarding).',
      'El chip **Citas** de cada fila es un interruptor: un clic lo prende o apaga para esa Empresa. No pide confirmación, y el efecto es inmediato -- si lo apagas, ese cliente pierde acceso a Citas by Shessai al instante, y cambia lo que se le factura.',
    ],
    rama: 'Antes de tocar el chip Citas de una empresa que no es tuya, confirma con quien la atiende que de verdad hay que prenderlo o apagarlo -- no hay forma de "deshacer" el clic, solo volver a tocarlo para revertirlo.',
    verTambien: [{ slug: 'plantillas-whatsapp-meta', titulo: 'Plantillas de WhatsApp: aprobar mensajes antes de que se puedan enviar' }],
  },
  {
    slug: 'comunicados-boletines',
    categoria: 'shessai',
    pantallas: ['announcements'],
    destacado: false,
    audiencia: 'shessai',
    tipo: 'instructiva',
    titulo: 'Comunicados: avisar algo a todas las Empresas a la vez',
    actualizado: '2026-09-15',
    contexto: 'Cuando Shessai necesita avisarle algo a TODOS los clientes al mismo tiempo -- una nueva función, una ventana de mantenimiento -- no se manda uno por uno: se publica un Comunicado y aparece dentro del CRM de cada Empresa. (En el título de la pantalla los vas a ver llamados "Boletines" -- es lo mismo.)',
    pasos: [
      'Toca **Nuevo Boletin**, escribe el **Título** y el **Texto** del aviso.',
      'Define la **Prioridad** (Alta, Mediana o Baja) -- controla qué tan destacado se ve el aviso dentro del CRM del cliente.',
      'Un comunicado marcado como **Inactivo** existe pero no se muestra a nadie -- útil para prepararlo con anticipación y activarlo el día que corresponda.',
    ],
    rama: null,
    verTambien: [],
  },
  {
    slug: 'plantillas-whatsapp-meta',
    categoria: 'shessai',
    pantallas: ['whatsapp-templates'],
    destacado: false,
    audiencia: 'shessai',
    tipo: 'explicativa',
    titulo: 'Plantillas de WhatsApp: aprobar mensajes antes de que se puedan enviar',
    actualizado: '2026-09-15',
    contexto: 'WhatsApp (a través de Meta, la empresa dueña de WhatsApp y Facebook) exige que ciertos mensajes automáticos -- como un recordatorio que un negocio manda sin que el cliente haya escrito antes -- usen una plantilla de texto aprobada de antemano. No se puede mandar cualquier texto libremente en esos casos. Esta pantalla es donde Shessai gestiona esas plantillas para los clientes.',
    pasos: [
      'Cada plantilla pasa por tres estados: **Pendiente** (esperando revisión), **Aprobada** (ya se puede usar para enviar mensajes) o **Rechazada** (Meta no la aceptó, hay que ajustarla y volver a mandarla).',
      'Tocar una plantilla muestra su **Vista previa** (cómo la va a ver el cliente final), sus **Variables** (partes que cambian en cada envío, como el nombre) y sus **Detalles**.',
    ],
    rama: null,
    verTambien: [{ slug: 'empresas-panel-superadmin', titulo: 'Empresas: administrar a todos los negocios que usan el CRM' }],
  },

  // ══════════════════════ SISTEMA ══════════════════════

  {
    slug: 'configuracion-marca-notificaciones',
    categoria: 'sistema',
    pantallas: ['settings', 'notifications'],
    destacado: false,
    audiencia: 'negocio',
    tipo: 'instructiva',
    titulo: 'Configuración: opciones generales, marca y notificaciones',
    actualizado: '2026-09-15',
    contexto: 'Es la pantalla más grande del CRM -- reúne ajustes de distintos temas en pestañas, no todos visibles para todos los planes.',
    pasos: [
      'La pestaña **Opciones** trae ajustes de comportamiento general: creación de usuarios, saludo automático al aceptar una sesión, si se ignoran mensajes de grupos, entre otros.',
      'La pestaña **Whitelabel** (solo en algunos planes) personaliza la marca: colores primarios para tema claro y oscuro, logo, favicon, imágenes de fondo, y qué idiomas están disponibles para tu empresa.',
      'Las **Notificaciones** push y de alertas NO están en esta pantalla -- tienen su propia entrada en el menú, aparte de Configuración.',
    ],
    rama: null,
    verTambien: [],
  },
  {
    slug: 'financiero-facturas',
    categoria: 'sistema',
    pantallas: ['financeiro'],
    destacado: false,
    audiencia: 'negocio',
    tipo: 'explicativa',
    titulo: 'Financiero: ver el estado de tus facturas',
    actualizado: '2026-09-15',
    contexto: 'Solo la ven perfiles admin. Es donde revisas si tu plan está al día o hay algo pendiente de pago.',
    pasos: [
      'Cada factura muestra su estado: pagada o vencida, entre otros.',
      'Si tu plan tiene un pago pendiente, esta es la pantalla donde vas a verlo reflejado -- no llega un aviso separado dentro de otra pantalla del CRM.',
    ],
    rama: null,
    verTambien: [],
  },
  {
    slug: 'api-mensajes-token',
    categoria: 'sistema',
    pantallas: ['messages-api'],
    destacado: false,
    audiencia: 'negocio',
    tipo: 'explicativa',
    titulo: 'API: conectar el CRM con un sistema externo',
    actualizado: '2026-09-15',
    contexto: 'Solo aparece si tu plan tiene la API externa habilitada. Es para cuando quieres que OTRO sistema (una web, un ERP) mande o reciba mensajes de WhatsApp a través de tu CRM, sin que un agente esté escribiendo a mano.',
    pasos: [
      'El token que necesitas para autenticar las llamadas NO se genera en esta pantalla: se copia desde **Conexiones**, editando la conexión de WhatsApp que va a enviar los mensajes.',
      'Con ese token, cada llamada a la API lleva `Authorization: Bearer {token}` -- esta pantalla trae el documento con los campos exactos que acepta cada tipo de envío (texto o con archivo adjunto).',
    ],
    rama: null,
    verTambien: [{ slug: 'conexiones-reiniciar', titulo: "Conexiones: por qué 'Reiniciar Conexiones' no pide confirmación" }],
  },
];
